import React from 'react';

const items = [
  {
    title: 'Australian, based in Melbourne.',
    body:
      'You work with a local practitioner in your timezone, not an offshore team you never meet. Available remote and on-site across Australia.',
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#38e0ff" strokeWidth="1.5" style={{ flex: 'none', marginTop: '2px' }}>
        <path d="M12 21s-7-6.2-7-11a7 7 0 0 1 14 0c0 4.8-7 11-7 11z" />
        <circle cx="12" cy="10" r="2.5" />
      </svg>
    ),
  },
  {
    title: 'Handled in-house.',
    body:
      'Your work is done by the person you hire, start to finish. Nothing is quietly subcontracted or sent offshore.',
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#38e0ff" strokeWidth="1.5" style={{ flex: 'none', marginTop: '2px' }}>
        <circle cx="12" cy="8" r="3.5" />
        <path d="M5.5 20a6.5 6.5 0 0 1 13 0" />
      </svg>
    ),
  },
  {
    title: 'Your data treated with care.',
    body:
      'Privacy and secure handling come first. Your data stays in trusted, Australian-region infrastructure, and we agree on access and confidentiality before any work begins.',
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#38e0ff" strokeWidth="1.5" style={{ flex: 'none', marginTop: '2px' }}>
        <rect x="5" y="11" width="14" height="9" rx="1.5" />
        <path d="M8 11V8a4 4 0 0 1 8 0v3" />
      </svg>
    ),
  },
];

const TrustStrip = () => (
  <section
    id="trust"
    style={{
      position: 'relative',
      zIndex: 4,
      background: 'linear-gradient(180deg, rgba(255,62,165,0.05) 0%, rgba(56,224,255,0.035) 100%)',
      borderTop: '1px solid rgba(255,255,255,0.06)',
      borderBottom: '1px solid rgba(255,255,255,0.06)',
    }}
  >
    <div
      className="zk-grid-3 zk-section-gutter"
      style={{
        maxWidth: '1180px',
        margin: '0 auto',
        padding: '38px 56px',
        display: 'grid',
        gridTemplateColumns: 'repeat(3, 1fr)',
        gap: '40px',
      }}
    >
      {items.map((it, i) => (
        <div key={i} style={{ display: 'flex', gap: '16px', alignItems: 'flex-start' }}>
          {it.icon}
          <p style={{ margin: 0, fontSize: '14.5px', lineHeight: 1.6, color: 'rgba(232,238,240,0.74)', textWrap: 'pretty' }}>
            <strong style={{ color: '#fff', fontWeight: 600 }}>{it.title}</strong> {it.body}
          </p>
        </div>
      ))}
    </div>
  </section>
);

export default TrustStrip;
